import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog as SharedConfirmDialog } from '@packages/ui';

type ConfirmDialogType = 'warning' | 'danger' | 'info' | 'success';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  type?: ConfirmDialogType;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  confirmText,
  cancelText,
  ...props
}) => {
  const { t } = useTranslation(['common_ui', 'common']);

  return (
    <SharedConfirmDialog
      {...props}
      confirmText={confirmText ?? t('common_ui:dialog.confirm.ok')}
      cancelText={cancelText ?? t('common:cancel')}
    />
  );
};

export default ConfirmDialog;
